const generateId = () => `${Date.now()}-${Math.floor((1 + Math.random()) * 0x1000000000).toString(16)}`;

// noinspection JSUnusedGlobalSymbols
export default generateId;
